
export default {
  name: 'PSelect',
  props: {
    value: {
      type: [String, Number, null],
      required: true,
      default: null,
    },
    title: {
      type: String,
      required: true,
      default: '',
    },
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    uniqueOptions() {
      return this.options.filter((option, index, self) => self.findIndex((t) => t.value === option.value) === index);
    },
    computedValue: {
      set(value) {
        this.$emit('input', value);
      },
      get() {
        return this.value;
      },
    },
  },
};
